import React, { useEffect, forwardRef, useState } from 'react';
import Reload from '../Assets/reload-svgrepo-com.svg';
import { Data } from '../LandingPage/mockData';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import './style.css';
import Accordion from 'react-bootstrap/Accordion';
import { QnAData } from './mockData';

const ResultQnaPage = ({handleStatus, handleRowClick, Data}) => {

    const [SelectQus, setSelectQus] = useState(true);
    const [EnterQus, setEnterQus] = useState(false);
    const [Questions, setQuestions] = useState([]);
    const [EnteredQus, setEnteredQus] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [AnswerData, setAnswerData] = useState("");
    const [ChatWindow, setChatWindow] = useState(false);

    const handleClick = () => {
        // handleStatus(false)
    }

    const handleEnterQus = () => {
        setEnterQus(true)
        setIsLoading(false)
        if(EnterQus !== true){
          setSelectQus(false)
        }
    }
      
    const handleSelectQus = () => {
        setSelectQus(true)
        setIsLoading(false)
        if(SelectQus !== true){
          setEnterQus(false)
        }
    }

    const handleChange = (e) => {
        setEnteredQus(e.target.value)
    }

    const handleGetAnswer = async () => {
        setIsLoading(true);
        setQuestions(EnteredQus)
        setChatWindow(true)
        setEnteredQus('')
        // try {
        //     setIsLoading(true);
        //     const Payload = { 'Ques': EnteredQus};
        //     const { data } = await axios.post('http://127.0.0.1:8000/api/upload/', Payload, {
        //         headers: { 'Content-Type': 'multipart/form-data' },
        //     });
        // if(data){
        //     setEnteredQus('')
        // }
        // } catch (error) {
        //     console.error("Error uploading file:", error);
        // } finally {
        //     setIsLoading(false);
        // }
    }

  return (
    <div className="d-flex flex-wrap" style={{ height: "100%", width: "100%" }} >
      <div className="" style={{ height: "100%", width: "100%" }}>
        <div
          className="ps-1 pe-4"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: 'center',
            width: "100%",
            height: "12%",
          }}
        >
          <p
            className="text-start mb-0"
            style={{ fontSize: "14.5px", fontWeight: "500", color: '#000' }}
          >
            Question & Answer
          </p>
            <OverlayTrigger
                key="left"
                placement="left"
                overlay={
                    <Tooltip id="tooltip-left">
                        <p className='mb-0'>Regenerate</p>
                    </Tooltip>
                    }
            >
                <img
                    src={Reload}
                    style={{ width: "20px", cursor: "pointer" }}
                    onClick={handleClick}
                />
            </OverlayTrigger>
            </div>
                <div style={{height: '10%'}}>
                    <ul className="nav nav-pills mb-0" id="pills-tab" role="tablist" style={{borderBottom: '1px solid lightgray'}}>
                      <li className="nav-item" role="presentation">
                        <button type="button" className={`tab ${SelectQus ? "tab-btn" : "tab-border-btn"}`} onClick={() => handleSelectQus()}>Generated Questions ({QnAData && QnAData.qa_data.length})</button>
                      </li>
                      <li className="nav-item mb-3" role="presentation">
                        <button type="button" className={`tab ${EnterQus ? "tab-btn" : "tab-border-btn"}`} onClick={() => handleEnterQus()}>Enter Questions</button>
                      </li>
                    </ul>
                </div>
            <div className="row sug-tab-top mb-3" style={{height: '78%', overflowY: 'auto'}}>
                {/* <hr /> */}
                <div className="d-flex mt-3">
                {SelectQus ?
                    <Accordion defaultActiveKey={0} flush style={{width: '100%'}}>
                    {QnAData && QnAData.qa_data.length > 0 &&
                              QnAData.qa_data.map((res, index) => (<>
                                {console.log(index, 'index')}
                    <Accordion.Item eventKey={index}>
                        <Accordion.Header><span style={{fontWeight: '400'}}>{index+1}.</span> &nbsp; {res.question}</Accordion.Header>
                        <Accordion.Body className='text-start' style={{fontSize: '14px'}}><span style={{fontWeight: '600'}}>Ans:</span> &nbsp; {res.answer}</Accordion.Body>
                    </Accordion.Item>
                    </>
                    ))}
                    </Accordion>:
                    <div style={{width: '100%',height: '100%'}}>
                        <div className={`d-flex ${ChatWindow ? 'align-items-end' : 'align-items-center'} justify-content-center`} style={{height: 'calc(100% - 70px)'}}>
                            {ChatWindow ? 
                            <div className='pb-3' style={{width: '100%', display: 'flex', flexWrap: 'wrap',justifyContent: 'space-between'}}>
                                <div className='d-flex flex-wrap justify-content-end' style={{width:'100%'}}>
                                    <span style={{background: '#0473ea', color: '#fff', padding: '12px 16px',borderRadius: '30px', fontSize: '13px'}}>{Questions} ?</span>
                                </div>
                                <div className='d-flex flex-wrap justify-content-start' style={{width:'100%'}}>
                                    <span style={{background: '#fff', border: '1.5px solid #0473ea', color: '#0473ea', padding: '12px 16px',borderRadius: '30px', fontSize: '13px'}}>{'your answer'}</span>
                                </div>
                            </div> :
                            <p className='text-center mb-0' style={{fontSize: '13px', color: 'gray'}}>We will Generate the Answer based on your question<br/>Ask your question and click Get Answer to Generate your Answers</p>
                            }
                        </div>
                        <div className='d-flex py-3' style={{height: '70px', borderTop: '1px solid lightgray'}}>
                        <input className="form-control form-control-sm" type="text" placeholder="Ask your Question" style={{width: "80%"}} value={EnteredQus} onChange={(e) => handleChange(e)}/>  
                        <div className="d-flex justify-content-start ms-4" style={{width: "20%"}}>
                            <button type="button" className="tab-ans" onClick={handleGetAnswer}>Get Answer</button>
                        </div>  
                        </div>    
                    </div>}
                </div>
            </div>
      </div>
    </div>
  );
};

export default ResultQnaPage;
